import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { INQUIRY_LIST_URL } from "../../utils/urls";
import instance from "../../services/services";
import BoardForm from "../../components/MyPage/BoardForm";
import PaginationSection from "../../components/Product/Pagination";
import useUserStore from "../../store/userStore";
import PopupLoginError from "../../components/Popup/LoginError";
import { useLanguage } from "../../hooks/useLanguage";

function CustomizingList(){
  const { t } = useLanguage();
    const navigate = useNavigate();
    const [questionList, setQuestionList] = useState([]);
    const { myInfo } = useOutletContext();
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;
    const { memberTokens } = useUserStore();
    const [isPopupLoginError, setIsPopupLoginError] = useState(false);
    
    const handleClickForm = () => {
      if (!memberTokens) {
        setIsPopupLoginError({
          message: t('login_required'),
          action: 'navigate_login'
        });
        return;
      }
      navigate('/community/customizing/write');
    };

    const handleConfirm = () => {
      navigate('/login');
    };
  
  // 1:1문의 리스트 api
  useEffect(() => {
    const fetchQuestionList = async () => {
      try {
        const response = await instance.post(INQUIRY_LIST_URL, {
          "boardid" : "custom",
          "offset" : currentPage,
          "limit" : itemsPerPage
        });
        setQuestionList(response.data.data.data);
        setTotalCount(response.data.data.cntRow);

      } catch (error) {
        console.error("1:1문의 목록 가져오기실패:", error);
      }
    };
    fetchQuestionList();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // window.scrollTo(0, 0); // 페이지 상단으로 스크롤
  };

  const handleArrowClick = (page) => {
    handlePageChange(page);
  };


    
  return(
    <div className="board_container">
      <h3 className="commu_title noline">{t("customization")}</h3>
      <div className="commu_box btm_btn_box">
        <div className="column flex-8">
          <h4 className="p2">{t("daypay_with_you_0617")}</h4>
          <p className="g-80 b1_2">
            {t("daypay_1_1_inquiry")}<br/>
            {t("camera_rental_related")}
          </p>
        </div>
        <button 
          type="button" 
          className="default_btn black"
          onClick={handleClickForm}
        >
          {t("write_article")}
        </button>
      </div>


      <div className="board_container form_board custom_box">
        <BoardForm
          isMyBoard = {true} 
          formType="customizing" 
          boardList={questionList}
          member_seq={myInfo?.member_seq}
          />
      </div>

      <PaginationSection
          totalCount={totalCount}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onArrow={handleArrowClick}
      />

      <PopupLoginError 
        isPopup={isPopupLoginError} 
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />
    </div>
  )
};

export default CustomizingList;